import { useState, useEffect, useContext } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import arrow from '../assets/arrow.png'
import strings from '../res/strings'
import TopNavBar from '../components/navigation/TopNavBar'
import RoundedButton from '../components/buttons/RoundedButton'
import RoundedBorderButton from '../components/buttons/RoundedBorderButton'
import CheckboxInput from '../components/inputs/CheckboxInput'
import ConfirmModal from '../components/modals/ConfirmModal'
import LoadingModal from '../components/modals/LoadingModal'
import * as Constants from '../utils/constants'
import { UserContext } from '../App'
import { isExpired } from 'react-jwt'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const NewEntitySkills = () => {
    const { state } = useLocation()
    let entityData = null

    if (state) {
        ( { entityData } = state)
    }

    const [skillsData, setSkillsData] = useState([])

    const [selectedHarbor, setSelectedHarbor] = useState(null)

    const [isFairingChecked, setIsFairingChecked] = useState(false)

    const [isElectricitySupplyChecked, setIsElectricitySupplyChecked] = useState(false)
    const [isAccessToFacilitiesChecked, setIsAccessToFacilitiesChecked] = useState(false)
    const [isMooringChecked, setIsMooringChecked] = useState(false)

    const [showConfirmModal, setShowConfirmModal] = useState(false)

    const [isLoading, setIsLoading] = useState(false)

    const { loggedUser, setLoggedUser } = useContext(UserContext)
    const navigate = useNavigate()

    useEffect(() => {
        if(loggedUser !== null && loggedUser !== 'refresh') {
            const isTokenExpired = isExpired(loggedUser.jwtToken)

            if(isTokenExpired) {
                setLoggedUser(null)
                navigate('/')
            } else if(loggedUser.role !== Constants.Roles.ADMINIT) {
                navigate('/')
            }
        } else if (loggedUser === null) {
            navigate('/')
        }
    }, [loggedUser])

    useEffect(() => {
        let data = []

        if(entityData) {
            entityData.harbors.map((harbor) => {
                data.push({
                    value: harbor.value,
                    label: harbor.label,
                    skills: [],
                    selected: false,
                    firstItem: false
                })
            })

            data[0].selected = true
            data[0].firstItem = true

            setSelectedHarbor(data[0])

            setSkillsData(data)
        }
    }, [])

    // Handle changes in fairing checkbox
    const onChangeFairingChecked = () => {
        setIsFairingChecked(!isFairingChecked)

        if(!isFairingChecked) {
            setSkillsData((prevItems) =>
                prevItems.map((item) =>
                    item.value === selectedHarbor.value ? { ...item, skills: [...item.skills, 0] } : item
                )
            )  
                
        } else {
            setSkillsData((prevItems) =>
                prevItems.map((item) =>
                    item.value === selectedHarbor.value ? { ...item, skills: item.skills.filter(skill => skill !== 0) } : item
                )
            )

        }
    }

    // Handle changes in electricity supply checkbox
    const onChangeElectricitySupplyChecked = () => {
        setIsElectricitySupplyChecked(!isElectricitySupplyChecked)

        if(!isElectricitySupplyChecked) {
            setSkillsData((prevItems) =>
                prevItems.map((item) =>
                    item.value === selectedHarbor.value ? { ...item, skills: [...item.skills, Constants.SKILLS.electricitySupply] } : item
                )
            )
        } else {
            setSkillsData((prevItems) =>
                prevItems.map((item) =>
                    item.value === selectedHarbor.value ? { ...item, skills: item.skills.filter(skill => skill !== Constants.SKILLS.electricitySupply) } : item
                )
            )
        }
    }

    // Handle changes in access to facilities checkbox
    const onChangeAccessToFacilitiesChecked = () => {
        setIsAccessToFacilitiesChecked(!isAccessToFacilitiesChecked)

        if(!isAccessToFacilitiesChecked) {
            setSkillsData((prevItems) =>
                prevItems.map((item) =>
                    item.value === selectedHarbor.value ? { ...item, skills: [...item.skills, Constants.SKILLS.accessToFacilities] } : item
                )
            )
        } else {
            setSkillsData((prevItems) =>
                prevItems.map((item) =>
                    item.value === selectedHarbor.value ? { ...item, skills: item.skills.filter(skill => skill !== Constants.SKILLS.accessToFacilities) } : item
                )
            )
        }
    }

    // Handle changes in mooring checkbox
    const onChangeMooringChecked = () => {
        setIsMooringChecked(!isMooringChecked)

        if(!isMooringChecked) {
            setSkillsData((prevItems) =>
                prevItems.map((item) =>
                    item.value === selectedHarbor.value ? { ...item, skills: [...item.skills, Constants.SKILLS.mooring] } : item
                )
            )
        } else {
            setSkillsData((prevItems) =>
                prevItems.map((item) =>
                    item.value === selectedHarbor.value ? { ...item, skills: item.skills.filter(skill => skill !== Constants.SKILLS.mooring) } : item
                )
            )
        }
    }

    // Handle clicks in harbors
    const onClickHarbor = (harbor) => {
        setIsFairingChecked(checkSkillById(harbor.skills, 0))
        setIsElectricitySupplyChecked(checkSkillById(harbor.skills, Constants.SKILLS.electricitySupply))
        setIsAccessToFacilitiesChecked(checkSkillById(harbor.skills, Constants.SKILLS.accessToFacilities))
        setIsMooringChecked(checkSkillById(harbor.skills,Constants.SKILLS.mooring))

        setSkillsData((prevItems) =>
            prevItems.map((item) => ({
                ...item,
                selected: item.value === harbor.value,
            }))
        )

        setSelectedHarbor(harbor)
    }

    // Check if given skill exists in user skills
    const checkSkillById = (skills, skill) => {
        if (skills.indexOf(skill) !== -1) {
            return true
        } else {
            return false
        }
    }

    // Check if all harbors have at least one skill so the user can click 'Next' button
    const areFieldsInvalid = () => {
        let hasErrors = false

        skillsData.map((harbor) => {
            if(harbor.skills.length === 0) {
                hasErrors = true
            }
        })

        return hasErrors
    }

    // Create entity and navigate back to entities list
    const createEntity = () => {
        setShowConfirmModal(false)
        setIsLoading(true)

        let data = []
        const harbors = []

        if(entityData) {
            skillsData.map((harbor) => {
                let skills = []

                if(checkSkillById(harbor.skills, 0)) {
                    skills.push(Constants.SKILLS.fairingPutToDry)
                    skills.push(Constants.SKILLS.fairingPutToSwim)
                    skills.push(Constants.SKILLS.fairingLineChange)
                }
                
                if(checkSkillById(harbor.skills, Constants.SKILLS.electricitySupply)) {
                    skills.push(Constants.SKILLS.electricitySupply)
                }

                if(checkSkillById(harbor.skills, Constants.SKILLS.accessToFacilities)) {
                    skills.push(Constants.SKILLS.accessToFacilities)
                }

                if (checkSkillById(harbor.skills,Constants.SKILLS.mooring)) {
                    skills.push(Constants.SKILLS.mooring)
                }

                harbors.push({
                    HarborId: harbor.value,
                    SkillIds: skills
                })
            })

            data = {
                Name: entityData.name,
                NIF: entityData.nif,
                HarborSkills: harbors,
                Contractor: entityData.contractor,
                Active: entityData.active,
                Date: entityData.date
            }
        }

        // Create entity
        fetch('/api/Backoffice/CreateEntity', {
            method:'POST',
            headers: { 
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors',
            body: JSON.stringify(data)
        }).then(async response => {
            setTimeout(() => {
                setIsLoading(false)

                if (response.status === 200) {
                    navigate('/backoffice-entities')
                } else if (response.status === 409) {
                    showErrorToast(strings.createEntityNIFError)
                } else {
                    showErrorToast(strings.createEntityError)
                }
            }, 1000)

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
            }, 1000)
        })
    }

    // Handle show error toast
    const showErrorToast = (error) => {
        toast.error(error, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored'
        })
    }

    return (
       <>
            <TopNavBar />

            <div className='flex flex-col px-[12.5rem] min-h-screen mb-6'>

                { isLoading ?
                    <LoadingModal />
                :   <>
                        <div className='flex flex-row items-center mt-16 mb-12 space-x-2'>
                            <button onClick={() => navigate(-1)}>
                                <img className='h-5 w-5' src={arrow} alt='Voltar atrás'/>
                            </button>
                            <p className='font-montserrat font-semibold text-accent'>{strings.entityManagement} / {strings.newEntity}</p>
                        </div>

                        <p className='font-montserrat text-xl font-bold text-navy'>{strings.skills}</p>
                        <p className='font-montserrat text-sm mt-2'>{strings.newEntitySkillsInfo}</p>

                        <div className='flex flex-row mt-8 space-x-6'>
                            <div className='flex flex-1 flex-col border rounded-[0.625rem] border-neutral3 min-h-[26.25rem]'>
                                { skillsData ? 
                                    skillsData.map((item) => (
                                        <div 
                                            key={item.value} 
                                            className='p-5 border-b border-neutral3 cursor-pointer flex flex-row justify-between' 
                                            style={{ borderColor: item.selected ? '#007EB4' : '#DFDFDF', 
                                                    backgroundColor: item.selected ? '#D6F3FF' : '#FFF', 
                                                    borderWidth: (item.firstItem && item.selected) || item.selected ? 1 : null,
                                                    borderTopLeftRadius: item.firstItem ? 10 : null,
                                                    borderTopRightRadius: item.firstItem ? 10 : null }}
                                            onClick={() => onClickHarbor(item)}
                                        >
                                            <p className='font-montserrat' style={{ fontWeight: item.selected ? '700' : '400', color: item.selected ? '#007EB4' : '#232323' }}>{item.label}</p>
                                            <p className='font-montserrat text-accent'>{item.skills.length > 0 ? item.skills.length + ' ' + (item.skills.length > 1 ? strings.skills2 : strings.skill) : null}</p>
                                        </div>
                                    ))
                                : null }
                            </div>

                            <div className='flex flex-1 flex-col border rounded-[0.625rem] border-neutral3 min-h-[26.25rem]'>
                                
                                <div className='flex flex-row items-center p-4'>
                                    <CheckboxInput
                                        id='fairing'
                                        checked={isFairingChecked}
                                        onChange={onChangeFairingChecked}
                                        disableRipple
                                    />
                                    <label htmlFor='fairing' className='font-montserrat cursor-pointer text-neutral-black'>{strings.fairing}</label>
                                </div>

                                <div className='h-px bg-neutral3'/>

                                <div className='flex flex-row items-center p-4'>
                                    <CheckboxInput
                                        id='electricitySupply'
                                        checked={isElectricitySupplyChecked}
                                        onChange={onChangeElectricitySupplyChecked}
                                        disableRipple
                                    />
                                    <label htmlFor='electricitySupply' className='font-montserrat cursor-pointer text-neutral-black'>{strings.electricitySupply}</label>
                                </div>

                                <div className='h-px bg-neutral3'/>

                                <div className='flex flex-row items-center p-4'>
                                    <CheckboxInput
                                        id='accessToFacilities'
                                        checked={isAccessToFacilitiesChecked}
                                        onChange={onChangeAccessToFacilitiesChecked}
                                        disableRipple
                                    />
                                    <label htmlFor='accessToFacilities' className='font-montserrat cursor-pointer text-neutral-black'>{strings.accessToFacilities}</label>
                                </div>

                                <div className='h-px bg-neutral3'/>

                                <div className='flex flex-row items-center p-4'>
                                    <CheckboxInput
                                        id='mooring'
                                        checked={isMooringChecked}
                                        onChange={onChangeMooringChecked}
                                        disableRipple
                                    />
                                    <label htmlFor='mooring' className='font-montserrat cursor-pointer text-neutral-black'>{strings.mooring}</label>
                                </div>

                                <div className='h-px bg-neutral3'/>

                            </div>
                        </div>

                        <div className='flex flex-row mt-10 justify-between'>
                            <div className='flex w-60'>
                                <RoundedBorderButton 
                                    text={strings.back}
                                    onClick={() => navigate(-1)}
                                    height={48}
                                    fontWeight='700'
                                />
                            </div>
                        
                            <div className='flex w-60'>
                                <RoundedButton 
                                    onClick={() => setShowConfirmModal(true)}
                                    text={strings.createEntity}
                                    height={48}
                                    bgColor='#007EB4'
                                    disabled={areFieldsInvalid()}
                                />
                            </div>
                        </div>
                        
                    </>
                }

            </div>

            <ConfirmModal
                open={showConfirmModal}
                onClose={() => setShowConfirmModal(false)}
                title={strings.createEntity2}
                message={strings.createEntityMessage}
                buttonText1={strings.cancel}
                buttonText2={strings.confirm}
                onClick={createEntity}
            />

            <ToastContainer />
       </>
    )
}

export default NewEntitySkills